import React, { useEffect, useState } from 'react'
import imageLogin from '../../../images/connecter.png'
import logo from '../../../images/logo3.png'
import { useNavigate, Link } from 'react-router-dom'
import Spinner from '../../elements/Spinner'

const HeaderHome = ({ profil, user }) => {
    const [montage, setMontage] = useState(true)
    let navigate = useNavigate()

    useEffect(() => {
        window.scrollTo(0, 0)
        setMontage(false)
    },[])

    if (montage) return <Spinner />

    return (
        <div>
            <div className='row py-3 shadow bg-body' style={{ height:'4rem' }}>
                <div className='col-2 text-center'>
                    <img src={logo} alt='logo' style={{ height:'2.2rem', width:'2.2rem' }} />
                </div>
                <div className='col text-end align-self-center'>
                    {profil.map(p => (
                        <span key={p.id}>{p.nomEntreprise}</span>
                    ))}
                </div>
                <div className='col-2 text-end align-self-center' style={{cursor:'pointer'}}>
                    <Link to='/authUser' state={{ keyUid:user.uid }} style={{ color:'black' }}>
                        <img src={imageLogin} alt='profil' style={{ height:'2.2rem', width:'2.2rem' }} />
                    </Link>
                </div>
            </div>
            {/* <div className='text-center mx-auto'>
                <img src={logo} className='img-fluid w-50 p-2' alt='image du logo' />
            </div>  */}
        </div>
    )
}

export default HeaderHome

/*
                <Link to='/authUser' state={{ keyUid:keyUid }} style={{ color:'black' }}>
                    <i className="bi bi-person-circle" style={{ fontSize:'2.2rem', cursor:'pointer' }}></i>
                </Link>
*/